var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-batch-grant',{ref:"form",staticClass:"pt-batch-grant__withData",attrs:{"type":_vm.type,"statisticeData":_vm.statisticeData,"submitLoading":_vm.submitLoading},on:{"submit":_vm.submit}})}
var staticRenderFns = []

export { render, staticRenderFns }